import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { isNullOrUndefined } from 'util';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { Observable } from 'rxjs';

import { Cxcencdepcli } from "../cxcinterfaces/cxcencdepcli";
import { Cxcdetdepcli } from "../cxcinterfaces/cxcdetdepcli";

@Injectable({
  providedIn: 'root'
})
export class CxcdepositocliService {
  public encdepcli: Cxcencdepcli[] = [];
  //public detregcomp: Cxcdetregcomp[][] = [];
  public _detdepcli: Cxcdetdepcli[];
  get detdepcli(): Cxcdetdepcli[] {
    return this._detdepcli;
  }

  set detdepcli(value: Cxcdetdepcli[]) {
    this._detdepcli = value;
  }
  public regtotal
  private way: string;
  constructor(
    private confIniciales: ConfInicialesService,
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario, private utilitariosService: UtilitariosService,
  ) {
    this.way = sessionStorage.getItem('way');
  }


  validacedulas() {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/faab26a98e6fa8000000', {
      elementos: {
        usuario:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertartmpdepcli(registros) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/95f8edf55db658000000', {
      elementos: {
        arreglo:registros,
        
        usuario:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }

  getnomcli() {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/10776f8b2f6ee3000', {
      elementos: {
        usuario:this.usuario.identificacion
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdepositos(arreglo, codban) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/20eeb5d96564e', {
      elementos: {
        usuario:this.usuario.identificacion,
        bancod: codban
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdepositosdetdepcli(arreglo, codban) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/10775aeeb5d965000', {
      elementos: {
        usuario:this.usuario.identificacion,
        bancod: codban
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  calculartotal() {
    let total = 0
    for (const iterator of this.detdepcli) {
      total = this.utilitariosService.sumar(total, iterator.DETDEPCLI_IMPORTE)
    }
    this.regtotal = this.utilitariosService.formatear(total, 2)
  }
  encontrarBanco(strCondicion): Observable<any> {
    return this.http.post<any[]>(this.way + '/cxc/cxcregcompo/3aecc5fab55d98', {
      elementos: {
        condicion: strCondicion
      },

    }, this.confIniciales.httpOptions()
    );
  }
  erpBanCliCodigo(banCliCodigo) {
    return this.http.post(this.way + '/cxc/cxcdepcli/3eaac9aa5aaeec000000000', {
      elementos: {
        BANCLI_CODIGO: banCliCodigo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validabancosdet(arreglo) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/3eaac9aa5aaecc000000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarregistro(item) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/95f8edf54ebb18000000', {
      elementos: {
        p_ENCDEPCLI_NUMERO: item.ENCDEPCLI_NUMERO,
        p_COM_CODIGO: '01',
        p_ENCDEPCLI_FECHA: item.ENCDEPCLI_FECHA,
        p_ENCDEPCLI_CONCEPTO: item.ENCDEPCLI_CONCEPTO,
        p_ENCDEPCLI_ESTADO:item.ENCDEPCLI_ESTADO,
        p_USUIDENTIFICACION: this.usuario.identificacion,
        p_BAN_CODIGO: item.BAN_CODIGO,
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  insertarregistrodet(areglodet) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/95f8edf54d7758000000', {
      elementos: {
        areglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizarregistro(item) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/533aebb1aecb2c0', {
      elementos: {
        p_ENCDEPCLI_NUMERO: item.ENCDEPCLI_NUMERO,
        p_COM_CODIGO: '01',
        p_ENCDEPCLI_FECHA: item.ENCDEPCLI_FECHA,
        p_ENCDEPCLI_CONCEPTO: item.ENCDEPCLI_CONCEPTO,
        p_ENCDEPCLI_ESTADO: item.ENCDEPCLI_ESTADO,
        p_USUIDENTIFICACION: this.usuario.identificacion,
      
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  actualizarregistrodet(areglodet) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/533ad775aecb2c0', {
      elementos: {
        areglodet
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getencdepcli(encdepcli) {

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/83baebb1aecb280', {
      elementos: {
        p_ENCDEPCLI_NUMERO: encdepcli ,
        p_COM_CODIGO: '01',
       
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getdetdepcli(encdepcli){

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/83bad775aecb280', {
      elementos: {
        p_ENCDEPCLI_NUMERO: encdepcli ,
        p_COM_CODIGO: '01',
       
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  borrarRegistro(encdepcli){

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/eacad2bab6ebb00000000', {
      elementos: {
        p_ENCDEPCLI_NUMERO: encdepcli ,
        p_COM_CODIGO: '01',
       
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminadetregistro(item){

    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/eacad2bab6d7780000000', {
      elementos: {
        p_ENCDEPCLI_NUMERO: item.ENCDEPCLI_NUMERO ,
        p_COM_CODIGO: '01',
        p_ban_codigo : item.BAN_CODIGO,
        p_DETDEPCLI_COMPROBANTE :item.DETDEPCLI_COMPROBANTE
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  seleccionarRegistro(tipo, numero): Observable<any> {
    return this.http.post<any>(this.way + '/cxc/cxcdepcli/71d573192c5d5c0000000000', {
      elementos: {
        p_tipo: tipo,
        p_com_codigo: '01',
        p_ENCDEPCLI_NUMERO: numero
      }
    }, this.confIniciales.httpOptions());
  }
  generaranticipos(numero) {
    return this.http.post<any>(this.way + '/cxc/cxcdepcli/83aeedab6abf68000000', {
      elementos: {

        p_ENCDEPCLI_NUMERO: numero,
        p_com_codigo:'01',
        p_usu_identificacion:this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  reversaranticipos(numero) {
    return this.http.post<any[]>(this.way + '/cxc/cxcdepcli/1b77ddbe2b6abf00000000', {
      elementos: {

        p_ENCDEPCLI_NUMERO: numero,
        p_com_codigo:'01',
        p_usu_identificacion:this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getvencodigo() {
    return this.http.post<any>(this.way + '/cxc/cxcdepcli/83bbf75d986ca00', {
      elementos: {
        user:this.usuario.identificacion
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
